module.exports = __webpack_public_path__ + "img/empty.2f366838.svg";